module.exports = __webpack_public_path__ + "static/company-culture-is-very-powerful-but-its-being-lost-at-home-3ff13e0de144a5e4938bfee59144c3ff.png";